<div class="flex flex-row flex-wrap justify-content-center pt-8">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        @if (loopDetected) {
            <div class="text-center mb-5">
                <div class="text-900 text-3xl font-medium mb-3">Sign-in keeps restarting</div>
                <p>
                    Several sign-ins with Microsoft were started within one minute, so we paused before Microsoft
                    throttles your account. Wait a minute, close any other tabs of QCT360, then try again. If it keeps
                    happening, contact <a href="mailto:info@qualicoat.net">info&#64;qualicoat.net</a>.
                </p>
            </div>
        } @else {
            <div class="text-center mb-5">
                <div class="text-900 text-3xl font-medium mb-3">Login failed. Please try again.</div>
            </div>
        }

        <div class="flex w-full justify-content-center">
            <!-- Full navigation on purpose: MSAL returns to the page a sign-in started from, which must not be this one. -->
            <a href="/dashboard">
                <p-button class="w-full" pRipple>Try again</p-button>
            </a>
        </div>
    </div>
</div>
